import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// NOTE: Using function declaration instead of const arrow to prevent TDZ errors in production builds
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
